import { TypographyProps } from '@mui/material/Typography';
import { FC, ReactNode, memo } from 'react';

import InplaceSelectEdit from '../../../ui/components/InplaceEdits/InplaceSelectEdit';
import { textWithHighlightedRegions } from '../../../ui/services/highlighting';
import createMultiElementHighlighter from './createMultiElementHighlighter';
import replaceMarkdownLinks from './replaceMarkdownLinks';

type Props = {
  readonly value: string | null;
  readonly allowLinks?: boolean;
  readonly highlights?: ReadonlyArray<string>;
  readonly canEdit?: boolean;
  readonly variant?: TypographyProps['variant'];
  readonly choices: ReadonlyArray<string>;
  readonly onSubmit?: (value: string) => void;
};

const Selects: FC<Props> = ({
  value,
  highlights,
  choices,
  allowLinks = false,
  canEdit = false,
  variant = 'body2',
  onSubmit,
}: Props) => {
  let textComponents: ReactNode = value ?? '';
  if (value) {
    textComponents = allowLinks
      ? replaceMarkdownLinks(value, createMultiElementHighlighter(highlights))
      : textWithHighlightedRegions(value, highlights);
  }
  const editValue = value ?? '';
  const choicesWithDefault = [
    { display: '---', value: '*' },
    ...choices.map((val) => ({ display: val, value: val })),
  ];
  const handleSubmit = (val: string) => {
    if (val === '*') {
      onSubmit?.('');
    } else {
      onSubmit?.(val);
    }
  };
  return (
    <InplaceSelectEdit
      textComponents={<span>{textComponents}</span>}
      onSubmit={handleSubmit}
      editValue={editValue}
      canEdit={canEdit}
      variant={variant}
      dense
      minWidth="250px"
      choices={choicesWithDefault}
      defaultChoice="*"
    />
  );
};

export default memo(Selects);
